import { json } from "utils/http/client";

export const PettyCashApi = {
  getWallet: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/wallet/`, {
      method: "GET",
    }),

  createWallet: (orgId, totalPettyCash) =>
    json(`/finance/org/${orgId}/petty-cash/wallet/`, {
      method: "POST",
      body: { total_petty_cash: Number(totalPettyCash) },
    }),

  credit: (orgId, amount, remarks = "") =>
    json(`/finance/org/${orgId}/petty-cash/credit/`, {
      method: "POST",
      body: {
        amount: Number(amount),
        remarks: String(remarks || ""),
      },
    }),

  transfer: (orgId, payload) =>
    json(`/finance/org/${orgId}/petty-cash/transfer/`, {
      method: "POST",
      body: payload,
    }),

  getTeamAllocations: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/get-team-allocations/`, {
      method: "GET",
    }),

  getOverview: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/overview/`, {
      method: "GET",
    }),

  getApprovals: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/approvals/`, {
      method: "GET",
    }),

  actionApproval: (orgId, approvalId, status, remarks = "") =>
    json(`/finance/org/${orgId}/petty-cash/approvals/${approvalId}/action/`, {
      method: "PATCH",
      body: {
        status: String(status || "").toUpperCase(),
        remarks: String(remarks || ""),
      },
    }),

  getMyRequestedApprovals: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/my-requested-approvals/`, {
      method: "GET",
    }),

  executeTransactionsFromApproval: (orgId, approvalId) =>
    json(`/finance/org/${orgId}/execute-transactions-from-approval/${approvalId}/`, {
      method: "POST",
    }),

  getApprovalDetail: (orgId, approvalId) =>
    json(`/finance/org/${orgId}/petty-cash/approvals/${approvalId}/`, {
      method: "GET",
    }),

  getMyWalletOverview: (orgId) =>
    json(`/finance/org/${orgId}/petty-cash/my-wallet-overview/`, {
      method: "GET",
    }),

  updateSpendableLimit: (orgId, employeeId, spendableBalance) =>
    json(`/finance/org/${orgId}/petty-cash/update-spendable-limit/`, {
      method: "POST",
      body: {
        employee_id: Number(employeeId),
        spendable_balance: Number(spendableBalance),
      },
    }),
};
